import { Helmet } from 'react-helmet'

const DEFAULT_IMAGE = 'https://sitiodetiendas.com/logosdt256.png'

export default function HelmetHeaders({
    title,
    description,
    image = DEFAULT_IMAGE,
    type = 'website',
    url,
    noIndex = false,
}) {
    const origin = window.location.origin
    const path = window.location.pathname
    const currentUrl = url || `${origin}${path}`
    const imageUrl = image || DEFAULT_IMAGE

    return (
        <Helmet>
            { title ? <title>{title}</title> : '' }
            { description ? <meta name="description" content={description} /> : '' }

            <link rel="canonical" href={currentUrl} />

            { title ? <meta property="og:title" content={title} /> : '' }
            { description ? <meta property="og:description" content={description} /> : '' }
            <meta property="og:url" content={currentUrl} />
            <meta property="og:type" content={type} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:width" content="256" />
            <meta property="og:image:height" content="256" />
            <meta property="og:image:type" content="image/png" />


            <meta name="twitter:card" content="summary_large_image" />
            { title ? <meta name="twitter:title" content={title} /> : '' }
            { description ? <meta name="twitter:description" content={description} /> : '' }
            <meta name="twitter:image" content={imageUrl} />

            {noIndex ? <meta name="robots" content="noindex,nofollow" /> : ''}
        </Helmet>
    )
}
